import { useLanguage } from "../stores/LanguageStore"

export async function getStringFromError(error) {
  const strings = useLanguage.getState().language.errors.main
  if (!error?.response?.data)
    return strings["unknown"]

  let message = error?.response.data?.state_message || ""

  if (error.response.data instanceof Blob) {
    await error.response.data.text().then((text) => {
      const json = JSON.parse(text)
      message = json.state_message
    });
  }

  if (error?.response?.data.state_message === "validation_exception") {
    return `Error: ${JSON.stringify(error?.response?.data?.errors)}`;
  }

  if (typeof error?.response?.data?.error_details === "string") {
    return error?.response?.data.error_details;
  }

  return strings?.[message] || `${error.response.status}: ${strings["unknown"]} ${message}`
}